export default __webpack_public_path__ + "static/media/synlab.87754a44.svg";